import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/allOrders',
        name: 'allOrders',
        component: () => import("./views/allOrders.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User]
        }
    },
    {
        path: '/ordersAdmin/:identifier',
        name: 'shopOrderAdmin',
        component: () => import("./views/shopOrderAdmin.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.SuperAdmin],
            hideHelpButton: true
        }
    },
    {
        path: '/orders',
        name: 'orders',
        component: () => import("./views/shopOrders.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User]
        }
    },
    {
        path: '/orders/:identifier',
        name: 'shopOrderDetail',
        component: () => import("./views/shopOrdersDetail.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User],
            hideHelpButton: true
        }
    },
];

export default routes;
